import { Component, ContentChild, Input, OnChanges, SimpleChanges, TemplateRef, HostAttributeToken, inject } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { NgTemplateOutlet, NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

export type HeaderType = 'page' | 'dialog' | 'card' | 'menu' | 'label' | 'caption';
export class HeaderConfig {
  public overflow?: 'wrap' | 'ellipsis' = 'wrap';
  public type?: HeaderType;
  constructor(
    public header: string | SafeHtml,
    public subheader: string | SafeHtml,
    public icon?: string,
    public suffixIcon?: string,
  ) {}
}

@Component({
  selector: 'lc-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    NgTemplateOutlet,
    MatIcon,
    NgClass,
  ],
})
export class HeaderComponent {
  readonly type? = inject(new HostAttributeToken('type'), { optional: true }) as HeaderType;

  @Input() config?: HeaderConfig;

  @Input() icon?: string;
  @Input() suffixIcon?: string;
  @Input() header?: string | SafeHtml;
  @Input() subheader?: string | SafeHtml;
  @Input() overflow?: 'wrap' | 'ellipsis' = 'wrap';

  @ContentChild('icon') iconTemplate?: TemplateRef<any>;
  @ContentChild('suffix') suffixTemplate?: TemplateRef<any>;

  headerClass: string;
  subheaderClass: string;

  constructor() {
    this.headerClass = this.getHeaderClass(this.type);
    this.subheaderClass = this.getSubheaderClass(this.type);
  }

  private getHeaderClass(type?: HeaderType) {
    if (type === 'dialog') { return 'mat-h3 font-weight-bold'; }
    if (type === 'card') { return 'mat-title font-weight-bold m-0 line-height-0'; }
    if (type === 'caption') { return 'mat-body-1 font-weight-500 m-0 line-height-0'; }
    return 'mat-body-2';
  }

  private getSubheaderClass(type?: HeaderType) {
    if (type === 'dialog') { return 'mat-body-1'; }

    if (type === 'card') { return 'mat-subheading-2 mat-hint m-0 line-height-0'; }
    if (type === 'caption') { return 'mat-caption m-0 line-height-0'; }
    return 'mat-caption';
  }
}
